import React from 'react';
import PropTypes from 'prop-types';

// Import components
import ProductDesktopView from './ProductSliderModuleDesktopView';
import ProductMobileView from './ProductSliderModuleMobileView';
import { getBreakpoint } from '../../../Base/Breakpoints';

class ProductController extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      module: 'mobile',
    };
    this.setModule = this.setModule.bind(this);
  }
  componentDidMount() {
    this.setModule();
    window.addEventListener('resize', this.setModule);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setModule);
  }

  setModule() {
    const breakpoint = getBreakpoint();
    const module = (breakpoint === 'sm') || (breakpoint === 'md') ? 'mobile' : 'desktop';

    if (module !== this.state.module) {
      this.setState({
        module,
      });
    }
  }

  render() {
    if (this.state.module === 'mobile') {
      return (
        <ProductMobileView
          {...this.props}
        />
      );
    }
    if (this.state.module === 'desktop') {
      return (
        <ProductDesktopView
          {...this.props}
        />
      );
    }

    return null;
  }
}

ProductController.propTypes = {
  slideModules: PropTypes.arrayOf(PropTypes.shape()),
};

ProductController.defaultProps = {
  slideModules: [],
};

export default ProductController;




// WEBPACK FOOTER //
// ./frontend/js/Components/Modules/ProductSliderModule/ProductController.jsx